import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      `peer p-0 h-4 w-4 ring-1 ring-[#B3B3B3] shrink-0 rounded-[3px] focus-visible:outline-none focus-visible:ring-1 
      focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 
      data-[state=checked]:bg-primary 
      data-[state=checked]:text-primary-foreground 
      data-[state=checked]:border-primary
      data-[state=checked]:ring-primary
      `,
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
